import { FC } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { BusinessOfficeItem } from "@/features/company/components/company-info/BusinessOfficeItem";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { blue } from "@/theme/colors";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { IconDeleteCompanyItem } from "@/assets/icons";
import { useDialog } from "@/hooks/useDialog";
import { ConfirmSaveModal } from "@/components/commons/ConfirmSaveModal";

type TBusinessOfficeInfo = {};
export const BusinessOfficeInfo: FC<TBusinessOfficeInfo> = ({}) => {
  const methods = useFormContext<TCompanyForm>();

  const { control, getValues } = methods;

  const confirmSave = useDialog();

  const handleDeleteItem = async (index: number) => {
    const value = getValues("businessOffices");
    if (value) {
      const off = value[index];
      const checkValue =
        !off.address && !off.city && !off.faxNumber && !off.officeDescription && !off.officeName && !off.prefecture && !off.telNumber && !off.zipCode;
      if (!checkValue) {
        const confirm = await confirmSave.show();
        if (confirm) {
          removeBusinessOffice(index);
        }
      } else {
        removeBusinessOffice(index);
      }
    }
  };

  const isShowAddBtnInList = (index: number) => {
    return index === businessOfficeArray.length - 1;
  };

  const isShowAddBtn = () => businessOfficeArray.length === 0;

  const {
    fields: businessOfficeArray,
    append: appendBusinessOffice,
    remove: removeBusinessOffice,
  } = useFieldArray({
    control,
    name: "businessOffices",
  });

  const addBusinessOffice = () => {
    appendBusinessOffice({
      officeName: "",
      zipCode: "",
      prefecture: "",
      city: "",
      address: "",
      telNumber: "",
      faxNumber: "",
      officeDescription: "",
    });
  };

  return (
    <>
      <InnerBox title={<CompanyFormTitle text="営業所情報" />} showDivider={false}>
        <Grid container>
          <Grid item xs={12}>
            {businessOfficeArray.map((field, index) => (
              <>
                <InnerBox title={<Typography variant="sub16Bold">{`営業所 ${index + 1}`}</Typography>} showDivider={false}>
                  <Stack key={index}>
                    <BusinessOfficeItem key={field.id} index={index} />
                  </Stack>
                </InnerBox>
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  gap={2}
                  sx={{
                    margin: "8px 0 16px 0",
                  }}
                >
                  {isShowAddBtnInList(index) && (
                    <Stack
                      alignItems="center"
                      direction="row"
                      sx={{
                        cursor: "pointer",
                      }}
                      spacing={0.5}
                      onClick={addBusinessOffice}
                    >
                      <AddCircleOutlineIcon
                        sx={{
                          color: blue[80],
                          fontSize: 18,
                        }}
                      />
                      <Typography variant="cap12Light"> 営業所を追加</Typography>
                    </Stack>
                  )}
                  <Stack
                    alignItems="center"
                    direction="row"
                    sx={{
                      cursor: "pointer",
                    }}
                    spacing={0.5}
                    onClick={() => handleDeleteItem(index)}
                  >
                    <IconDeleteCompanyItem />
                    <Typography variant="cap12Light">削除</Typography>
                  </Stack>
                </Stack>
              </>
            ))}
            {isShowAddBtn() && (
              <Stack
                alignItems="center"
                direction="row"
                sx={{
                  cursor: "pointer",
                }}
                spacing={0.5}
                onClick={addBusinessOffice}
              >
                <AddCircleOutlineIcon
                  sx={{
                    color: blue[80],
                    fontSize: 18,
                  }}
                />
                <Typography variant="cap12Light"> 営業所を追加</Typography>
              </Stack>
            )}
          </Grid>
        </Grid>
      </InnerBox>
      <ConfirmSaveModal title="削除の確認" open={confirmSave.open} onOk={confirmSave.confirm} onClose={confirmSave.cancel}>
        <Typography component="p" variant="subtitle1">
          「営業所情報」を削除してもよろしいですか？
        </Typography>
      </ConfirmSaveModal>
    </>
  );
};
